<template>
  <div class="Login">
    <el-container class="LoginBox">
      <el-dialog center :visible.sync="productActivated" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="true" width="40%">
        <div v-html="$t('activateProduct.titleDescriptionResponse')" style="text-align: center;"></div>
        <span slot="footer" class="dialog-footer"></span>
      </el-dialog>
      <el-dialog center :visible.sync="easterEgg" :show-close="true" :close-on-press-escape="true" width="20%">
        <div style="text-align: center;">
          <img :src="imageUrl" alt="c'est mortel" />
        </div>
      </el-dialog>
      <el-header class="LoginBox-header">
        <img alt="" src="@/assets/login_logo.png" srcset="@/assets/login_logo@2x.png 2x" />
      </el-header>
      <el-main class="LoginBox-main">
        <h1>{{ $t("activateProduct.title") }}</h1>
        <p>
          {{ $t("activateProduct.titleDescription") }}
        </p>
        <el-form
            ref="activationProductForm"
            label-position="top"
            :model="activationProductForm"
            :rules="activationProductFormRules"
            @submit-valid="tryActivate"
            @submit-error="onError"
        >
          <el-form-item prop="code">
            <template slot="label">{{ $t("activateProduct.labelCode") }}</template>
            <el-input type="text" v-model="activationProductForm.code" @blur="resetError()" />
          </el-form-item>
          <div v-if="error && activationProductForm.code != null && activationProductForm.code != undefined && activationProductForm.code != ''" class="error">{{ error }}</div>
          <el-button class="Login-formSubmit w-100" native-type="submit" type="danger">{{ $t("activateProduct.labelButton") }}</el-button>
        </el-form>
      </el-main>
    </el-container>
    <div class="Login-footer">
      <a :href="websiteUrl" target="_blank" rel="noopener">{{ $t("general.ubiflowWebsite") }}</a>
    </div>
  </div>
</template>

<script>
import i18next from 'i18next'
import { decryptData } from '@/services/annonceur'

export default {
  name: 'activateProduct',
  components: {},
  inject: ['browserContext'],
  metaInfo () {
    return {
      title: this.$t('activateProduct.pageTitle'),
      htmlAttrs: { class: 'Root--login' }
    }
  },
  data () {
    return {
      websiteUrl: processEnvConfig.VUE_APP_UBIFLOW_WEBSITE_URL,
      activationProductForm: {},
      activationProductFormRules: {
        code: { required: true, message: this.$t('activateProduct.codeRequired') }
      },
      error: null,
      productActivated: false,
      easterEgg: false,
      imageUrl: 'https://kaamelott-gifboard.fr/gifs/cest-mortel.gif'
    }
  },
  methods: {
    onError (error) {
      this.error = error
    },
    async tryActivate () {
      this.error = null
      const { code } = this.activationProductForm
      if (code) {
        if (code === '=catapulte') {
          this.easterEgg = true
        } else {
          // RzVYrb1X
          const response = await decryptData({ data: code })
          if (response.error) {
            this.error = response.error
          } else {
            this.productActivated = true
          }
        }
      }
    },
    resetError () {
      this.error = null
    }
  },
  computed: {
    logoCustomerSpace () {
      if (i18next.language === 'mx') {
        return 'logo_espace_client_ubiflow_es'
      }
      return 'logo_espace_client_ubiflow_' + i18next.language
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.el-loading-spinner {
  top: 10% !important;
}

html.Root--login {
  &,
  body {
    height: 100%;
  }

  body {
    align-items: center;
    background: url("~@/assets/login_background.jpg");
    @include image-retina("~@/assets/login_background.jpg", 2880, 1620);
    background-position: center center;
    background-size: cover !important;
    background-attachment: fixed;
    background-repeat: no-repeat;
    display: flex;
    flex: 1;
    justify-content: center;
    padding: 0;
    @media screen and (max-height: 760px) {
      align-items: flex-start;
    }
  }
}

.Login {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .LoginBox {
    @extend .card, .mx-4, .mb-5;
    max-width: 420px;
    margin-top: map-get($spacers, 5) * 2 !important;
    @media screen and (max-height: 760px) {
      margin-top: 60px + map-get($spacers, 5) * 2 !important;
    }

    h1 {
      border-bottom: 1px solid $blue;
      @include media-breakpoint-down(xs) {
        // Cannot use @extend in media
        padding-bottom: map-get($spacers, 4) !important; // pb-4
      }
    }

    &-header {
      position: absolute;
      text-align: center;
      transform: translateY(-100%);
      top: map-get($spacers, 5) * -1;
      width: 100%;
      height: 60px;

      img {
        max-width: 100%;
      }
    }

    &-main {
      @extend .card-body;
    }

    &-footer {
      background: $yellow-pastel;
      @extend .card-footer;
    }
  }

  &-slogan {
    @extend .font-secondary;
    color: $white;
    font-size: $font-size-base * 2;
    font-weight: lighter;
    line-height: $font-size-base * 2.5;
    position: absolute;
    right: 20%;
    text-align: center;
    top: 50%;
    transform: translate(50%, -50%);
    width: 200px;
  }

  &-footer {
    @extend .px-4, .py-3, .text-right;
    font-size: $font-size-sm;
    background: rgba(22, 64, 77, 0.8);
    bottom: 0;
    font-weight: lighter;
    left: 0;
    position: fixed;
    right: 0;

    @media screen and (max-height: 760px) {
      position: static;
      width: 100%;
    }

    a {
      color: $white;
    }
  }
}

.error {
  color: #d24554;
}
</style>
